module.exports = __webpack_public_path__ + "img/t3-silver.67331404.jpg";